import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'components/common/App';

import { initErrorReporting } from 'lib/observability';

// Before the first render, so a crash during mount is reported too.
initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
